module.exports = __webpack_public_path__ + "img/delete.f87f6c63.png";